/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import AudioFile from "./AudioFile";
import MonitorImg from "../../../icons/MonitorImg.svg";
import { ReactComponent as MonitorO } from "../../../icons/MonitorImg.svg";
import useTabSvg from "../../../icons/useTabSvg.svg";
import Refresh from "../../../icons/Refresh.svg";
import { ReactComponent as FacilitySvg } from "../../../icons/FacilitySvg.svg";
import cloudlog from "../../../icons/cloudlog.svg";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { AppBar } from "@material-ui/core";
import { Tabs } from "@material-ui/core";
import { Tab } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import "./Monitordetails.css";
import { getOneMonitor } from "./_redux/monitorCrud";
import Users from "../Users/Users";
import CloudActivityLog from "./CloudActivityLog";
import MonitorLog from "./MonitorLog";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as Actions from "../redux/action";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
}));

function MonitorDetails(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const tabChange = (event, newValue) => {
    switch (newValue) {
    }
    props.handleDelete(false);
    setValue(newValue);
  };

  const [state, setState] = useState({
    monitor: null,
    status: true,
    error: null,
  });
  useEffect(() => {
    props.searchMonitor("");
    const id = props.match.params.id;
    fetchOneMonitor(id);
  }, []);

  const refreshMonitorDetails = () => {
    const id = props.match.params.id;
    fetchOneMonitor(id);
    props.refreshAudio(true);
  };

  const fetchOneMonitor = (id) => {
    setState({ ...state, loading: true, monitors: [] });
    getOneMonitor(id)
      .then((res) => {
        const { data, status, message } = res.data;

        if (status) {
          setState({
            ...state,
            monitor: data[0],
            status: true,
            loading: false,
            error: null,
          });
        } else {
          setState({
            ...state,
            status: false,
            loading: false,
            error: message,
          });
        }
      })
      .catch((error) => {
        setState({
          ...state,
          status: false,
          loading: false,
        });
        if (error.response) {
          if (error.response.status !== 404 && error) {
            setState({
              ...state,
              error: error.response.data.message,
              loading: false,
            });
          } else {
            props.history.push("error/error-v1");
          }
        } else {
          setState({ ...state, error: error.message, loading: false });
        }
      });
  };

  return (
    <div>
      {!state.monitor ? (
        <div class="col-md-12 pageLoader">
          {state.error ? (
            <p className="errortxt">{state.error}</p>
          ) : (
            <span className="spinner spinner-dark "></span>
          )}
        </div>
      ) : (
        <>
          <div
            style={{
              height: "56px",
              backgroundColor: "white",
              width: "100%",
            }}
          >
            <span
              style={{
                color: "black",
                fontSize: 18,
                fontWeight: "600",
                fontFamily: "Noto Sans Display",
                marginLeft: "100px",
                display: "flex",
                height: "56px",
                alignItems: "center",
              }}
              id="monitorSelect"
            >
              {state.monitor &&
              state.monitor !== "undefined" &&
              state.monitor.assigned_facility.name ? (
                <FacilitySvg style={{ marginRight: "30px", marginTop: "0%" }} />
              ) : (
                <MonitorO style={{ marginRight: "30px", marginTop: "0%" }} />
              )}

              <span className="fac-name">
                {state.monitor &&
                  state.monitor !== "undefined" &&
                  state.monitor.assigned_facility.name}{" "}
              </span>
              {state.monitor &&
              state.monitor !== "undefined" &&
              state.monitor.assigned_facility.name ? (
                <span style={{ color: "#AEAEAE", paddingRight: "5px" }}>
                  {" "}
                  /{" "}
                </span>
              ) : null}
              <span style={{ color: "#158380" }}>
                {state.monitor &&
                  state.monitor !== "undefined" &&
                  state.monitor.monitor_id}
              </span>
            </span>
          </div>
        </>
      )}
      {!state.monitor ? (
        <div class="col-sm-12 hidden">
          <span className="ml-3 spinner spinner-dark "></span>
        </div>
      ) : (
        <div className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={tabChange}
              aria-label="simple tabs example"
              indicatorColor="red"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#17BCB7",
                  height: "6px",
                },
              }}
              textColor="black"
              style={{
                background: "white",
                border: "1px",
                borderColor: "#E1E1E1",
                borderStyle: "solid",
                width: "calc(100% + 16px)",
                marginLeft: "-3px",
                minHeight: "57px",
              }}
              centered
            >
              <Tab
                label="Monitor"
                iconPosition="start"
                icon={
                  <img
                    src={MonitorImg}
                    alt="MonitorImg"
                    style={{ marginRight: "10px" }}
                  ></img>
                }
                {...a11yProps(0)}
                style={{
                  color: "#313233",
                  position: "absolute",
                  left: "-16px",
                  fontFamily: "Noto Sans Display",
                  fontSize: 16,
                  fontWeight: 600,
                  marginTop: "-9px",
                }}
              />
              <Tab
                label="Users"
                iconPosition="start"
                icon={
                  <img
                    src={useTabSvg}
                    alt="useTabSvg"
                    style={{ marginRight: "10px" }}
                  ></img>
                }
                {...a11yProps(1)}
                style={{
                  color: "#313233",
                  position: "absolute",
                  left: "170px",
                  fontFamily: "Noto Sans Display",
                  fontSize: 16,
                  fontWeight: 600,
                  marginTop: "-9px",
                }}
              />

              <Tab
                label="Monitor Log"
                iconPosition="start"
                icon={
                  <img
                    src={require("../../../icons/monitorlog.png")}
                    alt="monitorlog"
                    style={{ marginRight: "10px" }}
                  ></img>
                }
                {...a11yProps(2)}
                style={{
                  color: "#313233",
                  position: "absolute",
                  left: "360px",
                  fontFamily: "Noto Sans Display",
                  fontSize: 16,
                  fontWeight: 600,
                  marginTop: "-9px",
                }}
              />
              <Tab
                label="Cloud Log"
                iconPosition="start"
                icon={
                  <img
                    src={cloudlog}
                    alt="cloudlog"
                    style={{ marginRight: "10px" }}
                  ></img>
                }
                {...a11yProps(3)}
                style={{
                  color: "#313233",
                  position: "absolute",
                  left: "580px",
                  fontFamily: "Noto Sans Display",
                  fontSize: 16,
                  fontWeight: 600,
                  marginTop: "-9px",
                }}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <>
              <button
                className="button-refresh-monitorGrid"
                onClick={refreshMonitorDetails}
              >
                <img className="imgCloud" src={Refresh} alt="Refresh"></img>
                <span className="imgCloudSpan">Refresh</span>
              </button>
            </>
            <AudioFile
              monitor={state.monitor}
              status={state.status}
              error={state.error}
              loading={state.loading}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <div className="md-userlist">
              <Users
                facility_user={
                  state.monitor &&
                  state.monitor !== "undefined" &&
                  state.monitor.assigned_facility.id
                }
              ></Users>
            </div>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <MonitorLog
              monitor={state.monitor}
              status={state.status}
              error={state.error}
            ></MonitorLog>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <CloudActivityLog monitor={state.monitor}></CloudActivityLog>
          </TabPanel>
        </div>
      )}
    </div>
  );
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleDelete: Actions.handleDelete,
      refreshAudio: Actions.refreshAudio,
      searchMonitor: Actions.searchMonitor,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    isDelete: state.isDelete,
    isRefreshAudio: state.isRefreshAudio,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MonitorDetails);
